/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.unifiedaccount.rpc.AccountRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './AccountRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.unifiedaccount.rpc.AccountRpc#deleteAccount
 */
export const DELETE_ACCOUNT_QUERY_FIELD_NAME = 'com_hubspot_unifiedaccount_rpc_AccountRpc_deleteAccount';
export const DELETE_ACCOUNT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: DELETE_ACCOUNT_QUERY_FIELD_NAME,
  args: ['accountId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.deleteAccountRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.unifiedaccount.rpc.AccountRpc#listAccountsForApp
 */
export const LIST_ACCOUNTS_FOR_APP_QUERY_FIELD_NAME = 'com_hubspot_unifiedaccount_rpc_AccountRpc_listAccountsForApp';
export const LIST_ACCOUNTS_FOR_APP_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_ACCOUNTS_FOR_APP_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.listAccountsForAppRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});